import { rootApi } from "..";
import { authService } from "../../../Api/Services/AuthService/AuthService";
import { ILoginArgs } from "../../../features/login/types";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

export const employeeAuthEndpoints = [
  {
    name: "authLogin",
    type: "mutation",
    serviceFn: ({ email, password }: ILoginArgs) =>
      authService.login(email, password),
  },
] as const;

export const employeeAuthApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, employeeAuthEndpoints),
});

export const { useAuthLoginMutation } = employeeAuthApi;
